import './ConfirmDelete.scss';
import classNames from 'classnames';
import { getDirectParent } from '@lib/popups';
import { Popconfirm, Tooltip } from 'antd';
import { COPY_GENERIC, COPY_SPECIFIC, MESSAGES_COPY } from '@sonar-software/sonar-ts-constants';
import { haltClickEventPropagation, handleEscape, off, on } from '@lib/events';
import React, { useMemo } from 'react';
import { useBoolean, useOnMount, useOnUnmount } from '@hooks';
export const ConfirmDelete = ({ cancelButtonProps, children, className, confirmButtonProps, getPopupContainer, id, placement = 'bottom', onConfirm, onCancel, title = MESSAGES_COPY.ARE_YOU_SURE, tooltip }) => {
    const [isOpen, setIsOpen] = useBoolean(false);
    const handleEscapePressed = useMemo(() => handleEscape(setIsOpen.off), [setIsOpen.off]);
    useOnMount(() => {
        on('keyup', handleEscapePressed);
    });
    useOnUnmount(() => {
        off('keyup', handleEscapePressed);
    });
    const getContainer = getPopupContainer ?
        (triggerNode) => getPopupContainer(getDirectParent(triggerNode)) :
        getDirectParent;
    return (React.createElement("div", { className: classNames('confirm-delete-wrapper', className), onClick: haltClickEventPropagation },
        React.createElement(Tooltip, { placement: placement, title: tooltip, trigger: ['hover', 'click'] },
            React.createElement(Popconfirm, { cancelButtonProps: cancelButtonProps, cancelText: (cancelButtonProps === null || cancelButtonProps === void 0 ? void 0 : cancelButtonProps.value) || COPY_GENERIC.CANCEL, className: 'confirm-delete', getPopupContainer: getContainer, id: id, okButtonProps: confirmButtonProps, okText: (confirmButtonProps === null || confirmButtonProps === void 0 ? void 0 : confirmButtonProps.value) || COPY_SPECIFIC.DELETE, okType: 'danger', onCancel: onCancel, onConfirm: onConfirm, onOpenChange: setIsOpen.toggle, open: isOpen, overlayClassName: 'confirm-delete-popup', placement: placement, title: title }, children))));
};
